import { useEffect } from "react";
import Lenis from "lenis";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/store/Header";
import { Hero } from "./components/store/Hero";
import { Marquee } from "./components/store/Marquee";
import { BrandBanner } from "./components/store/BrandBanner";
import { Socials } from "./components/store/Socials";
import { Bento } from "./components/store/Bento";
import { Catalog } from "./components/store/Catalog";
import { WhyUs } from "./components/store/WhyUs";
import { Faq } from "./components/store/Faq";
import { Newsletter } from "./components/store/Newsletter";
import { Footer } from "./components/store/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App grain relative min-h-screen bg-ink text-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <BrandBanner />
        <Bento />
        <Catalog />
        <WhyUs />
        <Faq />
        <Socials />
        <Newsletter />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}
